exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-link svg {\n  fill: rgba(255, 255, 255, 0.8) !important;\n  width: 16px !important;\n  height: 16px !important;\n}\n.nav-link.active svg, .nav-link:hover svg {\n  fill: white !important;\n}", ""]);

// exports
